import { AuthProvider } from "react-admin";
import { getToken, removeToken, setToken } from "../utils/token.util";
import { API } from "./api.provider";
import jwt_decode from "jwt-decode";
interface ILoginPayload {
  username: string;
  password: string;
}

interface IApiAuth {
  access_token: string;
}

export const authProvider: AuthProvider = {
  getPermissions: (params: any) => Promise.resolve(params),
  checkAuth: () =>
    getToken() ? Promise.resolve() : Promise.reject(),

  checkError({ status }: any) {
    if (status === 401 || status === 403) {
      removeToken();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  async login(credentials: ILoginPayload) {
    try {
      const { data } = await API.post<IApiAuth>("/auth/login", {
        login: credentials.username,
        password: credentials.password,
      });
      const decoded: any = jwt_decode(data.access_token);
      // backend may place role at root or inside a `user` object
      const role = decoded.role || decoded?.user?.role;
      // debug help when reproducing login issues
      // eslint-disable-next-line no-console
      //console.debug("auth: decoded token:", decoded);
      if (role === "admin") {
        setToken(`Bearer ${data.access_token}`);
        return Promise.resolve();
      }
      throw new Error("Usuário precisa ser administrador para acessar o sistema.");
    } catch (error: any) {
      const message = error?.response?.data?.message || error?.message || "Erro no login";
      throw new Error(message);
    }
  },

  logout: async () => {
    removeToken();
    return Promise.resolve();
  },
};
